var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0",staticStyle:{"height":"500px","background":"orange","max-width":"100%"}},[_vm._v(" CarSale ")])
}
var staticRenderFns = []

export { render, staticRenderFns }